import React, { useState } from "react";
import classNames from "classnames";
import styles from "./Navbar.module.scss";
import { getAsset, getLogo } from "../../utils/assets";
import { getData } from "../../utils/data";
import { EAssetName, EData } from "../../interfaces/enum";
import { NavbarData } from "../../interfaces/interfaces";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const logo = getLogo();
  const avatar = getAsset(EAssetName.AVATAR);
  const data = getData(EData.NAVBAR) as NavbarData;
  const [indexSelected, setIndexSelected] = useState(-1);
  const navigate = useNavigate();

  return (
    <div
      className={classNames(
        styles.container,
        "d-flex",
        "flex-lg-column",
        "align-items-center",
        "justify-content-between"
      )}
    >
      <div className={classNames(styles.logo)}>
        <img src={logo} alt={logo} />
      </div>
      <div
        className={classNames(
          styles.itemsContainer,
          "d-flex flex-lg-column gap-4"
        )}
      >
        {data.items.map((item, index) => (
          <div
            className={classNames(
              styles.item,
              indexSelected === index && styles.focused
            )}
            key={index}
            onClick={() => {
              setIndexSelected(index);
              navigate(item.route);
            }}
          >
            <img src={getAsset(item.name as EAssetName)} alt={item.name} />
          </div>
        ))}
      </div>
      <div className={classNames(styles.avatar)}>
        <img src={avatar} alt={avatar} />
      </div>
    </div>
  );
};

export default Navbar;
